// export DsfSCBiaofulu from './Biaofulu.vue';
export const DsfSCBiaofulu = Vue.defineLazyComponent(()=>require('./Biaofulu.vue'));
// export DsfSCBiaotou from './Biaotou.vue';
export const DsfSCBiaotou = Vue.defineLazyComponent(()=>require('./Biaotou.vue'));
// export DsfSCBiaowei from './Biaowei.vue';
export const DsfSCBiaowei = Vue.defineLazyComponent(()=>require('./Biaowei.vue'));
// export DsfSCBudaimulubudingchang from './Budaimulubudingchang.vue';
export const DsfSCBudaimulubudingchang = Vue.defineLazyComponent(()=>require('./Budaimulubudingchang.vue'));
// export DsfSCDaimulubudingchang from './Daimulubudingchang.vue';
export const DsfSCDaimulubudingchang = Vue.defineLazyComponent(()=>require('./Daimulubudingchang.vue'));
// export DsfSCErweidanlie from './Erweidanlie.vue';
export const DsfSCErweidanlie = Vue.defineLazyComponent(()=>require('./Erweidanlie.vue'));
// export DsfSCErweishuanglie from './Erweishuanglie.vue';
export const DsfSCErweishuanglie = Vue.defineLazyComponent(()=>require('./Erweishuanglie.vue'));
// export DsfSCWenjuanbiao from './Wenjuanbiao.vue';
export const DsfSCWenjuanbiao = Vue.defineLazyComponent(()=>require('./Wenjuanbiao.vue'));